import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arrow-up\">\n<path d=\"M90.224,95.1l-48.918,48.918c-5.401,5.401-14.159,5.401-19.56,0l0,0c-5.401-5.401-5.401-14.159,0-19.56L90.224,55.98\n\tc5.399-5.399,14.152-5.399,19.551,0l68.478,68.478c5.401,5.401,5.401,14.159,0,19.56l0,0c-5.401,5.401-14.159,5.401-19.56,0\n\tL109.776,95.1C104.377,89.701,95.623,89.701,90.224,95.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-up.svg
// module id = P3Ow
// module chunks = 3